const API_PATH = '/battlechart/api/v1/';
const UPLOAD_PATH = `${API_PATH}bc/excel/upload`;
const AD_PATH = '/ad';
const RFIS_PATH = '/rfis/v1/staff/';
const RFIS_V1 = '/rfis/v1/';
const CLOUD_API = '/basic/api/v1';
const SOI_API = '/soi/api/v1';
const HDEC_API = '/integration/hdec/api/v1';
const COMMON_API = '/soi/api/v1';
const FOODS_API = '/integration/foods/backend/api/v1';
const UNILOG_PROCESSING_API = '/unilog-processing/api/v1';
const COMPLAINT_API = '/mix/core/admin';
const COMPLAINTIMG_API = '/mix/api/visitor';
const MIX_API = "/mix";
const MIX_NEWYEAR_API = '/mix/api/v1';
const Manual_API = '/mix/operation/api/v1';
const AIM_URL = '/home/iam';
const COREADMIN = '/core/admin';
const TENANT_API = '/basic/api/v1';
export {
  MIX_API,
  MIX_NEWYEAR_API,
  Manual_API,
  FOODS_API,
  API_PATH,
  UPLOAD_PATH,
  RFIS_V1,
  AD_PATH,
  CLOUD_API,
  RFIS_PATH,
  COMMON_API,
  SOI_API,
  UNILOG_PROCESSING_API,
  HDEC_API,
  COMPLAINT_API,
  COMPLAINTIMG_API,
  AIM_URL,
  COREADMIN,
  TENANT_API,
}
